// extracted by mini-css-extract-plugin
export default {"container":"XP-z","title":"YP-z","link":"ZP-z"};